<template>
  <div class="a7-painel-analise">
    <component
      :is="menuComponent"
      :itens="itens"
      v-model="filters"/>
  </div>
</template>

<script>
import A7PainelAnaliseListMobile from './A7PainelAnaliseListMobile'
import A7PainelAnaliseListDesktop from './A7PainelAnaliseListDesktop'
import VisaoRestResource from '../visao/VisaoRestResource'
import {FilterUtilities} from 'guaxinim-web'
import {defaultFilterConfiguration} from './A7PainelAnaliseDefaultConfigurations'
export default {
  name: "a7-painel-analise",
  components: {
    A7PainelAnaliseListMobile,
    A7PainelAnaliseListDesktop
  },
  data: () => ({
    itens: [],
    filters: {},
    configurations: {}
  }),
  computed: {
    menuComponent() {
      return ['xs', 'sm', 'md'].includes(this.$mq)
        ? 'a7-painel-analise-list-mobile'
        : 'a7-painel-analise-list-desktop'
    }
  },
  methods: {
    fetch() {
      const filterParamsString = FilterUtilities.createFilterParamsString(this.filters.filterParams)
      if ( !Object.keys(this.filters.configurations).length )
        this.filters.configurations = {...defaultFilterConfiguration}
      const {periodo, comparador, intervalo} = this.filters.configurations
      return VisaoRestResource
        .findVisaoComparativoDTO(filterParamsString, periodo, comparador, intervalo)
        .then(dados => this.itens = dados)
        .catch((err) => this.$gw.defaultExceptionHandler.handleUnknownException(err, this))
    },
    heavyFetch() {
      this.heavyTask(this.fetch())
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.heavyFetch()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.a7-painel-analise {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  user-select: none;
  padding: 0px;
  margin: 0px;
}
</style>
